import React, { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

import { Typography } from 'components';

interface TipProps {
  children: ReactNode;
}

const Wrapper = styled.div`
  display: flex;
  background: ${({ theme }) => theme.colors.dark_400};
  position: absolute;
  top: -15px;
  left: calc(100% + 30px);
  width: 400px;
  color: red;
  min-height: 72px;
  border-radius: 4px;
  align-items: center;

  &::before {
    content: '';
    width: 0;
    height: 0;
    border-top: 16px solid transparent;
    border-bottom: 16px solid transparent;
    border-right: 10px solid ${({ theme }) => theme.colors.dark_400};
    position: absolute;
    top: 20px;
    left: -10px;
  }
`;

const ContentTypography = styled(Typography)`
  ul {
    margin: 0;
    position: relative;
    list-style: none;
    margin-left: 0;
    padding-left: 0.6rem;

    li {
      margin-top: 5px;

      &::before {
        content: '•';
        position: absolute;
        left: 0;
      }

      &:first-child {
        margin-top: 0;
      }
    }
  }
`;

const Tip = ({ children }: TipProps): ReactElement => (
  <Wrapper>
    <ContentTypography px={4} py={3} type="type1" color="gray_200">
      {children}
    </ContentTypography>
  </Wrapper>
);

export default Tip;
